<template>
  <div class="weather-options-data-dialog"></div>
</template>

<script>
export default {
  name: "weather-options-data"
}
</script>

<style scoped>
.setting-item .count-limit-item {
  margin-bottom: 0;
}

.setting-item .count-limit-item span {
  margin: 0 8px;
}
.setting-item .content-item .el-checkbox {
  margin-right: 20px;
}
.count-limit-item /deep/ .el-radio {
  margin-top: 7px;
  margin-bottom: 3px;
}

.count-limit-item /deep/ .el-radio:first-child {
  margin-top: 0;
}

.count-limit-item /deep/ .el-radio-group {
  width: 80px;
}
</style>
